import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { CommonSchema } from './schemas/commonSchema'
import { BidderSlice } from './types'

export const useValidateBidderSid = (): void => {
  const { t: tc } = useTranslation('common')
  const { formState, getFieldState, setError, watch } = useFormContext<CommonSchema>()

  const formValues = watch()
  const { accountType, bidderId, bidderSid } = formValues

  useEffect(() => {
    if (
      accountType === 'yieldbird' ||
      bidderId?.rawData === undefined ||
      getFieldState('bidderSid').invalid
    )
      return

    if ((bidderId.rawData as BidderSlice).sidRequired && bidderSid === '') {
      setError('bidderSid', { message: tc('form.error.isRequired') })
    }
  }, [formState])
}
